import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_BADGE_STATE = {
  Default: "default",
  Info: "info",
  Success: "success",
  Danger: "danger",
  Neutral: "neutral",
  Accent: "accent",
} as const;

export type DSBadgeState = ObjectValues<typeof DS_BADGE_STATE>;
